module.exports = __webpack_public_path__ + "static/Dreamer.c2d61bcf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Dreamer.svg
// module id = 341
// module chunks = 198830598414290